var map = {
	"./basketball.webp": 1655,
	"./bti-img.webp": 1656,
	"./bti-title-en.webp": 1657,
	"./cup.webp": 1658,
	"./football.webp": 1659,
	"./im-img.webp": 1660,
	"./im-title-en.webp": 1661,
	"./sb-img.webp": 1662,
	"./sb-title-cn.webp": 1663,
	"./sb-title-en.webp": 1664,
	"./sbo-img.webp": 1665,
	"./sbo-title-cn.webp": 1666,
	"./sbo-title-en.webp": 1667,
	"./sport-bg.webp": 1668,
	"./sport-ctg.webp": 1669,
	"./title-cn.webp": 1670,
	"./title-en.webp": 1671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;